import { useSelector } from 'react-redux';

import type { RootState } from '../store';

export const useSelectIsHighlightOn = () =>
  useSelector((state: RootState) => state.uiSession.highlightOn);
export const useSelectIsRotationOn = () =>
  useSelector((state: RootState) => state.uiSession.rotationOn);
export const useSelectIsWindRotationOn = () =>
  useSelector((state: RootState) => state.uiSession.windRotationOn);
export const useSelectIsWeatherAnimationOn = () =>
  useSelector((state: RootState) => state.uiSession.weatherAnimationOn);
export const useSelectCarouselDuration = () =>
  useSelector((state: RootState) => state.uiSession.carouselMs);
export const useSelectGlobalSearchTerm = () =>
  useSelector((state: RootState) => state.uiSession.globalSearch);
export const useSelectUserIdleDuration = () =>
  useSelector((state: RootState) => state.uiSession.userIdleMs);
export const useSelectPreferredSortOrder = () =>
  useSelector((state: RootState) => state.uiSession.preferredSorting);
export const useSelectHighlightedAircraftRegistration = () =>
  useSelector(
    (state: RootState) => state.uiSession.highlightedAircraftRegistration,
  );
export const useSelectHighlightedAirports = () =>
  useSelector((state: RootState) => state.uiSession.highlightedAirports);
export const useSelectSearchText = () =>
  useSelector((state: RootState) => state.uiSession.searchText);
export const useSelectDefaultRegionId = () =>
  useSelector((state: RootState) => state.uiSession.defaultRegionId);
export const useSelectGeneralSettings = () =>
  useSelector((state: RootState) => {
    const s = state.uiSession;

    return {
      rotationOn: s.rotationOn,
      windRotationOn: s.windRotationOn,
      weatherAnimationOn: s.weatherAnimationOn,
      highlightOn: s.highlightOn,
      carouselMs: s.carouselMs,
      globalSearch: s.globalSearch,
      userIdleMs: s.userIdleMs,
      preferredSorting: s.preferredSorting,
      highlightedAirports: s.highlightedAirports,
      highlightedAircraftRegistration: s.highlightedAircraftRegistration,
    };
  });
